// AlertBox.jsx
import React from 'react';

const HuomioBox = ({ type = 'warning', title = '', info = '' }) => {
  return (
    <div className={`alert alert-${type} border-start-0 border-top-0 border-bottom-0 rounded-0 py-3 px-4`}>
      {title && <p className="mb-2"><strong>{title}</strong></p>}
      {info && <p className="mb-0 small text-muted">{info}</p>}
    </div>
  );
};

export default HuomioBox;